import { DESKTOP_BREAKPOINT, TABLET_BREAKPOINT, MOBILE_BREAKPOINT } from '../constants/breakpoints';

const BREAKPOINT_TO_TYPE = {
  [DESKTOP_BREAKPOINT]: 'desktop',
  [TABLET_BREAKPOINT]: 'tablet',
  [MOBILE_BREAKPOINT]: 'mobile',
};

const getBreakpointTypeTraitValue = (breakpoint) => BREAKPOINT_TO_TYPE[breakpoint] ?? 'desktop';

export default getBreakpointTypeTraitValue;
